import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DmsGridTemplateBase } from '../dms-grid-template-base';
import {
  IrisUserComponent,
} from '@iris/common/modules/user-common/modules/sk-user-wrapper/components/sk-iris-user.component';

@Component({
  selector: 'iris-dms-grid-creator-template',
  imports: [
    IrisUserComponent,
  ],
  templateUrl: './dms-grid-creator-template.component.html',
  styleUrls: ['./dms-grid-creator-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsGridCreatorTemplateComponent extends DmsGridTemplateBase { }
